import { SkeletonCircle, Image } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

const imageSize = '18px'

interface ProfileImageProps {
  imageUrl: string
  borderColor: string
}

const ProfileImage: React.FC<ProfileImageProps> = ({
  imageUrl,
  borderColor,
}) => {
  const { t } = useTranslation()

  return (
    <Image
      h={imageSize}
      w={imageSize}
      src={imageUrl}
      alt={t('profile.profileImageAltText')}
      objectFit="cover"
      fallback={<SkeletonCircle size={imageSize} />}
      borderRadius="full"
      border="1px"
      borderColor={borderColor}
    />
  )
}

export default ProfileImage
